module.exports = __webpack_public_path__ + "static/img/level_3.0f9a06d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/level_3.png
// module id = 7EVx
// module chunks = 1